export var OrderCompletionStatus;
(function(OrderCompletionStatus) {
    OrderCompletionStatus[/**
     * The [[OrderCompletion]] has been started, but has not yet finished.
     */ "Pending"] = "Pending";
    OrderCompletionStatus[/**
     * The [[InProgressOrder]] has been completed successfully.
     */ "Completed"] = "Completed";
    OrderCompletionStatus[/**
     * The [[OrderCompletion]] process has failed due to technical error.
     *
     * @remarks
     * Failed orders occur generally due to timeout or network issues as the Vista order is finalised.
     * Advanced clients may build recovery systems for this however support for the viability of the type of payments used and general circuit configuration.
     * For those clients without a recovery system this state must be manually reconciled as payments may have been taken and the order may exist.
     * In such cases a message to contact customer support is unfortunately the only option for a UI.
     */ "Failed"] = "Failed";
})(OrderCompletionStatus || (OrderCompletionStatus = {}));

//# sourceMappingURL=order-completion-status.js.map